import { WebPlugin } from '@capacitor/core';
export class MiniappSDKWeb extends WebPlugin {
    async isBiometricAvailable() {
        return { isAvailable: false, biometryType: 0 };
    }
    async verifyIdentity() {
        console.log('[Web] verifyIdentity called → dummy success');
        return;
    }
    async getCredentials() {
        console.log('[Web] getCredentials called → dummy data');
        return { username: 'demo', password: 'demo' };
    }
    async setCredentials() {
        console.log('[Web] setCredentials called → dummy success');
        return;
    }
    async deleteCredentials() {
        console.log('[Web] deleteCredentials called → dummy success');
        return;
    }
    async echo(options) {
        console.log('[Web] echo', options);
        return options;
    }
    async vibrate() {
        if (navigator.vibrate) {
            navigator.vibrate(200);
        }
        else {
            console.log('[Web] vibrate not supported, dummy fallback');
        }
    }
    async getLocation() {
        return new Promise((resolve) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((pos) => {
                    resolve({
                        lat: pos.coords.latitude,
                        lng: pos.coords.longitude,
                    });
                }, () => {
                    resolve({ lat: 10.762622, lng: 106.660172 }); // dummy HCM
                });
            }
            else {
                resolve({ lat: 10.762622, lng: 106.660172 });
            }
        });
    }
    async getBatteryInfo() {
        throw this.unimplemented('getBatteryInfo not available on web.');
    }
    async getSystemInfo() {
        return {
            model: 'Web Browser',
            osName: 'Web',
            osVersion: 'N/A',
            platform: navigator.platform,
            userAgent: navigator.userAgent,
        };
    }
    async getUserInfo() {
        //throw this.unimplemented('getUserInfo not available on web.');
        return { id: 'web-user', name: 'Web User' };
    }
    async getAppInfo() {
        // throw this.unimplemented('getAppInfo not available on web.');
        return { id: 'web-app', name: 'Web App', version: '1.0.0' };
    }
    async getCurrentLocation() {
        // throw this.unimplemented('getLocation not available on web.');
        return this.getLocation();
    }
    async closeApp() {
        // throw this.unimplemented('closeApp not available on web.');
        console.log('closeApp called - not available on web');
        return;
    }
    async openWebview(options) {
        window.open(options.url, '_blank');
    }
    async openMiniapp(options) {
        window.open(options.url, '_blank');
    }
    async getNetworkInfo() {
        // throw this.unimplemented('getNetworkInfo not available on web.');
        const nav = navigator;
        return {
            connected: nav.onLine,
            type: nav.connection ? nav.connection.effectiveType : 'unknown',
        };
    }
    async getAccessToken() {
        // throw this.unimplemented('getAccessToken not available on web.');
        return { clientId: 'web-client', accessToken: 'dummy-access-token' };
    }
    async scanQr() {
        // throw this.unimplemented('scanQr not available on web.');
        return { content: 'dummy-qr-content' };
    }
    async getPhoto(options) {
        console.log('getPhoto', options);
        throw this.unimplemented('getPhoto not available on web.');
        // return { path: '{camera-dummy-image}', webPath: '{camera-dummy-image}', base64String: '', dataUrl: '' };  
    }
    async pickImages(options) {
        console.log('pickImages', options);
        throw this.unimplemented('pickImages not available on web.');
        // return { image: '{pickimage-dummy-image}' };
    }
    async setNavigationBarColor(options) {
        console.log('color', options.color);
        throw this.unimplemented('setNavigationBarColor not available on web.');
    }
    async setStatusBarColor(options) {
        console.log('color', options.color);
        throw this.unimplemented('setNStatusBarColor not available on web.');
    }
    async getContacts() {
        console.log('getContacts called');
        // throw this.unimplemented('getContacts not available on web.');
        return { contacts: [{ name: 'John Doe', phone: '1234567890' }] };
    }
    async saveImageToGallery(options) {
        console.log('saveImageToGallery called', options);
        throw this.unimplemented('saveImageToGallery not available on web.');
    }
    async configAppView(options) {
        console.log('configAppView called', options);
        // throw this.unimplemented('configAppView not available on web.');
        return;
    }
    async requestCameraPermission() {
        console.log('requestCameraPermission called');
        throw this.unimplemented('requestCameraPermission not available on web.');
    }
    async getPermissions() {
        console.log('getPermissions called');
        throw this.unimplemented('getPermissions not available on web.');
    }
    async requestPermissions(options) {
        console.log('requestPermissions called', options);
        throw this.unimplemented('requestPermissions not available on web.');
    }
    async getDeviceLanguage() {
        const language = navigator.language || 'en-US';
        const [lang, country] = language.split('-');
        return { language: lang, country: country || '', displayName: language };
    }
}
//# sourceMappingURL=web.js.map